import clsx from 'clsx';
import { Building2, Globe, Layers, LogOut } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { NavLink, Outlet } from 'react-router-dom';
import { Logo } from '../../app/shell/Sidebar';
import { useSession } from '../../lib/session';

const ITEMS = [
  { to: '/admin/tenants', key: 'admin.tenants', icon: Building2 },
  { to: '/admin/plans', key: 'admin.plans', icon: Layers },
];

export function AdminShell() {
  const { t, i18n } = useTranslation();
  const { admin, logout } = useSession();
  return (
    <div className="flex h-dvh overflow-hidden bg-bg">
      <aside className="hidden h-full w-[232px] shrink-0 flex-col gap-1.5 bg-[#0b1a12] p-4 pt-6 text-text-on-brand md:flex">
        <Logo />
        <p className="-mt-3 mb-3 px-1.5 text-[11px] font-semibold uppercase tracking-wider text-accent">{t('admin.badge')}</p>
        <nav className="flex flex-col gap-1.5">
          {ITEMS.map((it) => (
            <NavLink key={it.to} to={it.to} className={({ isActive }) => clsx('flex min-h-11 items-center gap-3 rounded-md px-3.5 py-2.5 text-sm font-medium', isActive ? 'bg-accent text-accent-ink' : 'text-[#C9DECF] hover:bg-brand-active hover:text-white')}>
              <it.icon size={20} aria-hidden /> {t(it.key)}
            </NavLink>
          ))}
        </nav>
        <div className="flex-1" />
        <div className="flex items-center gap-2.5 px-1.5">
          <div className="min-w-0 flex-1">
            <div className="truncate text-[13px] font-semibold text-white">{admin?.name}</div>
            <div className="truncate text-[11px] text-text-on-brand-muted" dir="ltr">{admin?.email}</div>
          </div>
          <button className="btn-ghost -me-2 text-text-on-brand-muted hover:text-white" aria-label={t('nav.logout')} onClick={() => void logout()}><LogOut size={18} /></button>
        </div>
      </aside>
      <div className="flex min-w-0 flex-1 flex-col overflow-y-auto">
        <header className="flex items-center gap-3 border-b border-border bg-surface px-4 py-3 lg:px-7">
          <h1 className="text-lg font-bold">{t('admin.title')}</h1>
          <div className="flex-1" />
          <button className="btn-secondary size-10 !p-0" aria-label={t('common.language')} onClick={() => void i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en')}><Globe size={18} /></button>
          <button className="btn-ghost md:hidden" onClick={() => void logout()}><LogOut size={18} /></button>
        </header>
        <main className="flex flex-1 flex-col gap-5 p-4 lg:p-7"><Outlet /></main>
      </div>
    </div>
  );
}
